export const GAME_AGGREGATORS = {
  SOFTWISS: {
    ID: 1,
    NAME: 'softwiss'
  },
  HUB88: {
    ID: 2,
    NAME: 'hub88'
  },
  IGD: {
    ID: 3,
    NAME: 'I Gaming Deck'
  }
}
